export interface CreateSiteRequest {
    label?: { [key: string]: string; };
    resource_id?: string;
    site_name?: string;
    type?: CreateSiteRequest.TypeEnum;
}

export namespace CreateSiteRequest {
    export type TypeEnum = 'STORE' | 'BUY_SELL' | 'SUB_STORE' | 'VACATIONAL' | 'JOB' | 'HOME';
    export const TypeEnum = {
        STORE: 'STORE' as TypeEnum,
        BUYSELL: 'BUY_SELL' as TypeEnum,
        SUBSTORE: 'SUB_STORE' as TypeEnum,
        VACATIONAL: 'VACATIONAL' as TypeEnum,
        JOB: 'JOB' as TypeEnum,
        HOME: 'HOME' as TypeEnum
    };
}

